import { useRequestProcessing } from '@gogame/query';

import {
  uploadNewCampaigns,
  checkUploadCampaigns,
  getUploadErrors,
} from 'scenes/Campaigns/sources/campaigns';

import { grid } from '../queryKeyFactory';
import { messagesCampaigns } from '../messages';

export const useUploadNewCampaigns = () => {
  const importMessage = messagesCampaigns.import();

  return useRequestProcessing(
    grid(),
    uploadNewCampaigns,
    checkUploadCampaigns,
    {
      getCompletedMessage: () => importMessage.completed(),
      getFailedMessage: () => importMessage.failed(),
      getHasErrorsMessage: () => importMessage.completedWithErrors(),
      getProcessMessage: (result) =>
        importMessage.processing(result?.percentCompleted),
      onFailed: (_, { jobId }) => {
        getUploadErrors({ jobId });
      },
      onHasErrors: (_, { jobId }) => {
        getUploadErrors({ jobId });
      },
    }
  );
};
